/**
 * Singleton Keycloak-инстанс.
 *
 * ТЗ §2.2 листил `@react-keycloak/web` как обёртку, но он не получает
 * релизы с 2022 и плохо совместим с React 19. Делаем минимальный DIY-
 * провайдер (см. `KeycloakProvider.tsx`) поверх голого `keycloak-js`.
 */
import Keycloak from 'keycloak-js';

import { env } from '../consts/env';

const keycloak = new Keycloak({
  url: env.keycloakUrl,
  realm: env.keycloakRealm,
  clientId: env.keycloakClientId,
});

export default keycloak;

/** Опции init для production. `login-required` форсит редирект на Keycloak. */
export const KEYCLOAK_INIT_OPTIONS = {
  onLoad: 'login-required' as const,
  // Iframe-проверка ломается на cross-origin Keycloak и сжирает ресурсы
  // ради сомнительной выгоды. Refresh-токены покрывают тот же сценарий.
  checkLoginIframe: false,
  // Минимальный TTL обновления — 30 секунд до истечения.
  // Используется в axios-интерсепторе.
};
